import React from 'react';

import PropTypes from 'prop-types';

import { XSS_FILTER_OPTIONS, XSS_HARSH_FILTER_OPTIONS } from 'constants/Constants';

import { filterXSS } from 'xss';

import { Text } from '../Text/Text';

export const DangerouslyHtml = ({ sanitizeAllHtmlTags = false, ...props }) => {
    const data = filterXSS(props.dangerouslyHtml, sanitizeAllHtmlTags ? XSS_HARSH_FILTER_OPTIONS : XSS_FILTER_OPTIONS);

    if (props.type === 'text') {
        return <Text variant={props.variant} color={props.color} size={props.size} textAlign={props.textAlign} dangerouslySetInnerHTML={{ __html: data }} />;
    } else if (props.type === 'span') {
        return <span dangerouslySetInnerHTML={{ __html: data }} />;
    } else {
        return <div dangerouslySetInnerHTML={{ __html: data }} />;
    }
};

DangerouslyHtml.propTypes = {
    type: PropTypes.oneOf(['text', 'span']),
    dangerouslyHtml: PropTypes.string,
    variant: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'pre', 'paragraph', 'div', 'span', 'link', 'button']),
    size: PropTypes.oneOf(['display1', 'display2', 'header', 'main', 'secondary', 'subheader', 'tag']),
    color: PropTypes.oneOf(['darkGray', 'mediumGray', 'lightGray', 'purple', 'purpleRgba40', 'red', 'white', 'whiteRgba40']),
    textAlign: PropTypes.oneOf(['left', 'center', 'right']),
    sanitizeAllHtmlTags: PropTypes.bool,
};
